'use client';

import { useEffect, useState } from 'react';
import Container from '@/components/ui/container';
import SocialLinks from './social-links';
import Copyrights from './copyrights';
import DownloadApp from './download-app';
import PaymentLogos from './payment-logos';
import LinksListSection from './LinksListSection';
import { usePathname } from '@/i18n/navigation';
import useGlobalStore from '@/store/global.store';
import { shouldShowMainLayout } from '@/utils/global';

const Footer = ({ footerData, isMobile }) => {
  const pathname = usePathname();

  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const getFooterSection = (key) =>
    footerData?.find((item) => item?.active && item?.key === key);

  const linksList = getFooterSection('links-list');
  const socialLinksData = getFooterSection('social-links');
  const appLinks = getFooterSection('app-links');
  const payments = getFooterSection('payments');
  const isCart = pathname === '/cart';

  const showMainBlocks = shouldShowMainLayout(pathname);

  const setPaymentMethods = useGlobalStore((state) => state.setPaymentMethods);

  useEffect(() => {
    setPaymentMethods(payments);
  }, [payments]);

  return (
    <footer
      aria-label='Footer'
      className={`text-dark overflow-hidden border-t border-gray-200 bg-[#fafafa] ${
        isCart ? 'mb-[210px] sm:mb-0' : 'mb-[60px] sm:mb-0'
      }`}
    >
      {showMainBlocks && (
        <Container className='mx-auto px-4 py-7 max-sm:pt-2 md:px-6'>
          {/* Desktop 8-col grid */}
          <div className='hidden grid-cols-8 gap-6 lg:grid'>
            {mounted && linksList && (
              <LinksListSection
                linksList={linksList}
                isLast={false}
                isMobile={false}
                forceAll
              />
            )}
          </div>

          {/* Mobile accordion */}
          <div className='divide-y divide-gray-200 lg:hidden'>
            {mounted && linksList && (
              <LinksListSection
                linksList={linksList}
                isLast={false}
                isMobile={true}
                asAccordion
              />
            )}
          </div>

          {/* Meta row: Social • Stores • Payments */}
          <div className='mt-5 grid items-center gap-4 lg:grid-cols-[1.2fr_1fr_1fr]'>
            <div>
              <SocialLinks
                socialLinksData={socialLinksData}
                isMobile={isMobile}
              />
            </div>
            <div>
              <DownloadApp appLinks={appLinks} />
            </div>
            <div>
              <PaymentLogos isMobile={isMobile} isFromFooter={true} />
            </div>
          </div>
        </Container>
      )}

      <Copyrights />
    </footer>
  );
};

export default Footer;
